import { ArrowUpRight } from "lucide-react";
import { LOGOS, VENTURES, CONTACT_INFO } from "../../data/ventures";

export const Footer = () => (
  <footer data-testid="footer" className="relative border-t border-white/10 py-16">
    <div className="mx-auto max-w-[1440px] px-6 md:px-12">
      <div className="grid grid-cols-1 gap-12 md:grid-cols-[1.2fr_1fr_1fr]">
        <div>
          <div className="flex items-center gap-3">
            <img
              src={LOGOS.veerox}
              alt="Veerox Group"
              className="h-11 w-11 rounded-lg object-cover ring-1 ring-white/10"
            />
            <div>
              <span className="font-display text-lg font-bold tracking-tight text-white">
                VEEROX <span className="text-gradient-cyan">GROUP</span>
              </span>
              <div className="font-mono-tech text-[0.6rem] uppercase tracking-[0.28em] text-slate-400">
                Built for Success
              </div>
            </div>
          </div>
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">
            One group powering AI workforces, trading intelligence, enterprise
            software and premium food brands.
          </p>
        </div>

        <div>
          <h4 className="font-mono-tech text-xs uppercase tracking-[0.26em] text-slate-500">
            Our Ventures
          </h4>
          <ul className="mt-5 space-y-3">
            {VENTURES.map((v) => (
              <li key={v.id}>
                <a
                  href={v.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-link-${v.id}`}
                  className="group inline-flex items-center gap-1.5 text-sm text-slate-300 transition-colors duration-200 hover:text-cyan-300"
                >
                  {v.name}
                  <ArrowUpRight className="h-3.5 w-3.5 opacity-0 transition-opacity duration-200 group-hover:opacity-100" />
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-mono-tech text-xs uppercase tracking-[0.26em] text-slate-500">
            Reach Us
          </h4>
          <ul className="mt-5 space-y-3 text-sm text-slate-300">
            <li>
              <a
                href={CONTACT_INFO.whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="transition-colors duration-200 hover:text-cyan-300"
              >
                WhatsApp: {CONTACT_INFO.whatsapp}
              </a>
            </li>
            <li>
              <a
                href={CONTACT_INFO.phoneLink}
                className="transition-colors duration-200 hover:text-cyan-300"
              >
                Call Agent: {CONTACT_INFO.phone}
              </a>
            </li>
            {CONTACT_INFO.emails.map((em) => (
              <li key={em}>
                <a
                  href={`mailto:${em}`}
                  className="transition-colors duration-200 hover:text-cyan-300"
                >
                  {em}
                </a>
              </li>
            ))}
            <li className="text-slate-400">{CONTACT_INFO.location}</li>
          </ul>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center">
        <p className="font-mono-tech text-xs text-slate-500">
          © {new Date().getFullYear()} Veerox Group · Veerox Software. All rights reserved.
        </p>
        <p className="font-mono-tech text-xs uppercase tracking-[0.24em] text-slate-600">
          Built for Success!
        </p>
      </div>
    </div>
  </footer>
);
